import { List, ListItem, ListItemText } from "@mui/material";
import { Link, Outlet, useLocation } from "react-router-dom";
import styles from "../index.module.scss";
import Layout from "../../components/Layout";

const ExpensesMain = () => {
  const pigRoutes = [
    "Expenses",
    "Feeding",
    "Items",
    "Insurance",
    "Requisition",
    "Vaccination",
  ];
  const router = useLocation();
  const pathName = router.pathname;

  return (
    <Layout>
      <List className="page_nav">
        {pigRoutes.map((route) => (
          <ListItem
            key={route}
            component={Link}
            to={`/expenses/${route.toLowerCase()}`}
            className="flex-1"
            selected={`/expenses/${route.toLowerCase()}` === pathName}
            classes={{ root: styles.root, selected: styles.listItemSelected }}
          >
            <ListItemText primary={route} className={styles.listItemText} />
          </ListItem>
        ))}
      </List>
      <Outlet />
    </Layout>
  );
};

export default ExpensesMain;
